import {hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedSiteData} from "../../../tracking/algolytics_hits/tracked_utils/tracked_site";
import {getGaUserId} from "../../../tracking/tracking_utils/get_ga_user_id";
import {CreditAlgolyticsViewType} from "../types/CreditAlgolyticsViewType";

export interface ICreditViewAlgolytics {
    view_type: CreditAlgolyticsViewType;
}

export const CreditViewEvent = (eventPayload: ICreditViewAlgolytics) => {
    const {site_id} = getTrackedSiteData();

    hitAlgolytics("views", {
        site_id,
        gaId: getGaUserId(),
        ...eventPayload
    });
};
import {hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedSiteData} from "../../../tracking/algolytics_hits/tracked_utils/tracked_site";
import {getGaUserId} from "../../../tracking/tracking_utils/get_ga_user_id";
import {CreditAlgolyticsViewType} from "../types/CreditAlgolyticsViewType";

export interface ICreditViewAlgolytics {
    view_type: CreditAlgolyticsViewType;
}

export const CreditViewEvent = (eventPayload: ICreditViewAlgolytics) => {
    const {site_id} = getTrackedSiteData();

    hitAlgolytics("views", {
        site_id,
        gaId: getGaUserId(),
        ...eventPayload
    });
};
